import React from 'react'
import PropTypes from 'prop-types'
import './_MatchDetailVideoPanel.scss'
import store from 'src/store'
import { playFullMedia } from 'src/actions/playmedia'
import { getPlayBackData } from '../../../services/getPlayBack'
import { AAFPLAYER_STOP } from 'src/AAFPlayer/constants'
import BlockedChannels from 'src/utils/BlockedChannels'
import channelBlockedUtil from 'src/utils/ChannelBlockedUtil'
import { showModal, MODAL_PIN, MODAL_MATCH_DETAIL } from 'src/actions/modal'
import { MODAL_PIN_CODE_CHANNEL_TYPE } from 'src/components/Modal/ModalPinCode'
import Spinner from 'src/components/Spinner'
import asyncPinObserver from 'src/AAF/Pin/AsyncPinObserver'
import Translations from '../../../../../requests/apa/Translator';
import Asset from '../../../../../requests/apa/Asset'
import Device from 'src/devices/device.js'
import { setPendingMatchModal } from '../../pendingMatchModal'
import Utils, { showSpinner } from '../../../../../utils/Utils'
import { PurchaseButtonInfov585 } from '../../../../../requests/loader'
import PlayerStreamingUtils from '../../../../../utils/PlayerStreamingUtils'
import logger from 'src/utils/logger/logger';


/**
 * MatchDetailVideoPanel
 *
 * Columna derecha del layout EN VIVO (Figma B_31 — node 2739:62663)
 * Muestra:
 *  - Área de video con overlay "Presiona OK para ir al canal"
 *  - Barra de progreso en el borde inferior
 *  - Carrusel "Disponible en:" con logos de canales
 *
 * Props:
 *  - thumbnailUrl   {string}   URL de imagen de fondo del video (opcional)
 *  - channels       {array}    [ { logoUrl, name } ] — máx. 3
 *  - onSelectChannel {func}    Callback al presionar OK sobre el video
 */
var CHANNEL_WIDTH_REM    = 14.333
// Ancho visible de la ventana del carrusel: panel(53.867) - área del label(18)
var CHANNELS_WRAP_WIDTH  = 35.867

class MatchDetailVideoPanel extends React.Component {
  constructor (props) {
    super(props)
     this.state = { focusedIndex: 0, currentGroupId: null, isChannelBlocked: false, blockedGroupId: null, isLoading: false, channelNumber: null, numberOfChannels: null, hasInvalidMedia: false, retryCount: 0 }
    this._mounted = false
    this.handleChannelFocus = this.handleChannelFocus.bind(this)
    this.handleChannelKeyDown = this.handleChannelKeyDown.bind(this)
    this.restorePlayerToOriginal = this.restorePlayerToOriginal.bind(this)
    this._showPinModal = this._showPinModal.bind(this)
    this._handleMatchDetailParentalBlock = this._handleMatchDetailParentalBlock.bind(this)
    this._onDocFocusIn = this._onDocFocusIn.bind(this)
    this._getPipConfig = this._getPipConfig.bind(this)
    this._isExpanded = false
    this._orig = {}
    this.payloadGroupId = props.payloadGroupId
    this.player = Device.getDevice().getPlayer()
    this.pipConfig = this._getPipConfig(props.channels && props.channels.length === 1)
    this.isSamsungOrsay = Utils.isSamsungOrsay();

    //BORRAR MELO CONSOLA
    // const debugCtime = document.getElementById('debug-ctime');
    // if (debugCtime) debugCtime.innerHTML = "MELO- " + JSON.stringify(props);
  }

    // ── Valida que media tenga las propiedades requeridas para reproducción ────
  _hasValidMediaData (channel) {
    if (!channel || !channel.media) {
      return false
    }
    var media = channel.media
    var hasVideoUrl = media.videoUrl !== null && media.videoUrl !== undefined && media.videoUrl !== ''
    var hasServerUrl = media.serverUrl !== null && media.serverUrl !== undefined && media.serverUrl !== ''
    var hasChallenge = (media.challange !== null && media.challange !== undefined && media.challange !== '') ||
                       (media.challenge !== null && media.challenge !== undefined && media.challenge !== '')

    return hasVideoUrl && hasServerUrl && hasChallenge
  }

  _getPipConfig (isSingle) {
    // Medidas base en rems
    var baseMeasures = {
      top: 4.6,
      left: 64,
      width: 53.5,
      height: isSingle ? 29.2 : 29.2
    }

    // Detectar resolución de pantalla
    var screenHeight = window.innerHeight || window.screen.height
    var multiplier = 10 // Default para 720p

    // Si la altura es mayor o igual a 1080px,
    if (screenHeight >= 1080) {
      multiplier = 15
    }

    // Calcular valores en pixels
    return {
      top: Math.round(baseMeasures.top * multiplier),
      left: Math.round(baseMeasures.left * multiplier),
      width: Math.round(baseMeasures.width * multiplier),
      height: Math.round(baseMeasures.height * multiplier)
    }
  }

  // ── Reintenta cargar datos de playback si media es inválido ───────────────
  _retryPlayBackData () {
    var component = this
    var { leagueId, matchId, miniplayerRetryConfig, versionPlayBackConfig } = this.props
    var maxAttempts = miniplayerRetryConfig && miniplayerRetryConfig.attempts ? miniplayerRetryConfig.attempts : 0
    var currentRetryCount = this.state.retryCount

    // Si ya se agotaron los intentos
    if (currentRetryCount >= maxAttempts) {
      logger.debug('[MatchDetailVideoPanel] Agotados los reintentos de playback. Max attempts:', maxAttempts)
      component.setState({ hasInvalidMedia: true, isLoading: false, retryCount: 0 })
      return
    }

    // Esperar 500ms antes de reintentar
    setTimeout(() => {
      getPlayBackData(leagueId, matchId, miniplayerRetryConfig, versionPlayBackConfig).then((updatedPlayBackData) => {
        logger.debug('[MatchDetailVideoPanel] Reintento #' + (currentRetryCount + 1) + ' - PlayBackData:', updatedPlayBackData)

        // Verificar si media es válido en los canales
        var channels = updatedPlayBackData && updatedPlayBackData.channels ? updatedPlayBackData.channels : []
        var playableChannel = channels.find(function (ch) { return ch.media !== null && ch.events !== null })

        if (playableChannel && component._hasValidMediaData(playableChannel)) {
          // Media es válido, actualizar con nuevos canales y disparar reproducción
          logger.debug('[MatchDetailVideoPanel] Media válido en reintento, disparando reproducción del canal:', playableChannel.groupId)
          if (component._mounted) {
            var numberOfChannels = playableChannel.number
            component.setState({ retryCount: 0, hasInvalidMedia: false, isLoading: false }, () => {
              // Disparar reproducción después de actualizar el estado, pasando los canales actualizados
              component._checkBlockedChannelAndPlay(playableChannel.groupId, numberOfChannels, channels)
            })
          }
        } else {
          // Media sigue siendo inválido, reintentar
          if (component._mounted) {
            component.setState({ retryCount: currentRetryCount + 1 }, () => {
              component._retryPlayBackData()
            })
          }
        }
      }).catch((error) => {
        logger.error('[MatchDetailVideoPanel] Error en reintento de playback:', error)
        if (component._mounted) {
          component.setState({ retryCount: currentRetryCount + 1 }, () => {
            component._retryPlayBackData()
          })
        }
      })
    }, 500)
  }

  // ── Recibe evento del player cuando el canal requiere PIN parental ─────────
  _handleMatchDetailParentalBlock (event) {
    if (event === 'match_detail_channel_requires_pin') {
      var groupId = this.state.currentGroupId
      if (groupId && this._mounted) {
        if (this._playerObserver) {
          this._playerObserver.disconnect()
          this._playerObserver = null
        }
        this.setState({ isLoading: false })
        this._markChannelBlocked(groupId, [])
      }
    }
  }

  // ── Muestra el modal de PIN parental y reproduce si el usuario lo valida ──
_showPinModal () {
    var groupId = this.state.blockedGroupId
    var matchData = this.props.matchData
    var callback  = this.props.callback

    // Guardar el estado actual de la modal de Match Detail antes de abrir PIN
    if (matchData) {
      setPendingMatchModal({ matchData, callback });
    }

    store.dispatch(showModal({
      modalType: MODAL_PIN,
      modalProps: {
        type: MODAL_PIN_CODE_CHANNEL_TYPE,
        playFromMatchDetail: true,
        action: 'MP_CHECAR_STATUS',
        pinIsCreated: true,
        successCallBack: (enteredCode, pinIsCreated, checkPinResponse) => {
          // Notificar a AAFPlayerMain que este canal ya fue desbloqueado vía PIN
          asyncPinObserver.fire('match_detail_channel_unlocked:' + groupId)
          logger.debug('[MatchDetailVideoPanel] successCallBack - _mounted:', this._mounted, 'groupId:', groupId)
          // Esperar a que el modal se cierre completamente antes de reproducir
          setTimeout(() => {
            logger.debug('[MatchDetailVideoPanel] setTimeout - _mounted:', this._mounted)
            // Restaurar los estilos originales del reproductor (no depende de _mounted)
            this.restorePlayerToOriginal()

            //MELO Mundial 2026 - Usar datos de playback del channel en lugar de getMedia
            var channels = this.props.channels || []
            // Detectar si tenemos playbackData válido para usar flujo LITE
            var currentChannel = channels.find(function (ch) { return ch.groupId === groupId });
            const device_config = Device.getDevice().getConfig();
            const streamType = device_config && device_config.stream_type ? device_config.stream_type : 'smooth_streaming';
              logger.debug('[MatchDetailVideoPanel] Componente desmontado, intentando reproducir directamente')
              setPendingMatchModal({ matchData: matchData, callback: callback })
              showSpinner(true)
              store.dispatch(playFullMedia(Object.assign({
                playerstate: 'PLAYING',
                source: { videoid: groupId },
                ispreview: false,
                islive: true,
                size: { top: 0, left: 0, width: 792, height: 428 },
                ispip: false,
                showEpg: false,
                filterTV: undefined,
                event: null,
                playFromCard: true,
                playFromMatchDetail: true,
                playbackData: currentChannel.media,
                mundial2026: true,
                streamType: streamType,
              }, { pinAlreadyValidated: true, skipPin: true })))
           // }
          }, 500)
        },
        cancelCallBack: () => {
          // No hacer nada. El overlay bloqueado ya tiene su propio handler inline.
          // No volver a agregar el listener global para evitar memory leaks.
        }
      }
    }))
  }

  // ── Guarda los estilos originales de los elementos del player ──────────────
  _saveOriginalStyles () {
    var playerMain = document.getElementById('playerMain')
    if (playerMain) {
      this._originalPlayerMainStyle = {
        display      : playerMain.style.display,
        top          : playerMain.style.top,
        left         : playerMain.style.left,
        width        : playerMain.style.width,
        height       : playerMain.style.height,
        borderRadius : playerMain.style.borderRadius
      }
    }
    var videoWrapper = document.getElementById('HTML5VideoWrapper')
    if (videoWrapper) {
      this._originalVideoWrapperClass = videoWrapper.className
    }
    var uxMain = document.getElementById('uxMain')
    if (uxMain) {
      this._originalUxMainStyle = uxMain.getAttribute('style') || ''
    }
  }

  // ── Crea e inserta el pill CTA y la imagen del canal en document.body ───────
  _createCtaPill (channels) {
    var isSingleChannel = channels.length === 1
    var ctaWrap = document.createElement('div')
    ctaWrap.className = 'match-detail-video-panel__cta-wrap'
    if (isSingleChannel) ctaWrap.style.top = '34.2rem'

    var ctaPill = document.createElement('a')
    ctaPill.id = 'mdvp-cta-pill'
    ctaPill.className = 'focusable match-detail-video-panel__cta-pill'
    // ctaPill.text = 'Presiona OK para ir al canal'
    ctaPill.setAttribute('role', 'button')
    ctaPill.setAttribute('tabindex', '0')
    ctaPill.setAttribute('data-sn-down', '#mdvp-channel-0')
    this._ctaPillFocus = function () {
      var videoEl = document.getElementById('mdvp-video-area')
      if (videoEl) videoEl.classList.add('match-detail-video-panel__video--focused')
      var ctaPill = document.getElementById('mdvp-cta-pill')
      if (ctaPill) ctaPill.classList.add('match-detail-video-panel__cta-pill--focused')
    }
    this._ctaPillBlur = function () {
      var videoEl = document.getElementById('mdvp-video-area')
      if (videoEl) videoEl.classList.remove('match-detail-video-panel__video--focused')
      var ctaPill = document.getElementById('mdvp-cta-pill')
      if (ctaPill) ctaPill.classList.remove('match-detail-video-panel__cta-pill--focused')
    }
    ctaPill.addEventListener('focus', this._ctaPillFocus)
    ctaPill.addEventListener('blur', this._ctaPillBlur)
    if (isSingleChannel) ctaPill.style.top = '-5.4rem'

    if (typeof this.props.onSelectChannel === 'function') {
      var self = this
      this._ctaPillClick = function () {
        self.restorePlayerToOriginal()
        self.props.onSelectChannel(self.state.currentGroupId)
      }
      ctaPill.addEventListener('click', this._ctaPillClick)
      this._ctaPillKeyDown = function (e) {
        var k = e.keyCode || e.which
        if (k === 13 || k === 32 || k === 179 || k === 415) {
          e.preventDefault()
          e.stopPropagation()
          self._ctaPillClick()
        } else if (k === 40) {
          e.preventDefault()
          e.stopPropagation()
          var firstChannel = document.getElementById('mdvp-channel-0')
          if (firstChannel) {
            firstChannel.focus()
          } else {
            // Si no hay canales en el carrusel, ir a los tabs
            var firstTab = document.querySelector('.match-detail-tabs__tab')
            if (firstTab) firstTab.focus()
          }
        } else if (k === 37) {
          e.preventDefault()
          e.stopPropagation()
          var backBtn = document.getElementById('btnMundialBack')
          if (backBtn) backBtn.focus()
        }
      }
      ctaPill.addEventListener('keydown', this._ctaPillKeyDown)
    }

    var ctaText = document.createElement('p')
    ctaText.className = 'match-detail-video-panel__cta-text'
    if (isSingleChannel) ctaText.style.top = '1.7rem'
    ctaText.textContent = Translations.get('eventodeportivo_partidos_formasdever_boton_texto_presionaokiracanal')

    var playableChannelForImg = channels.find(function (ch) { return ch.media !== null && ch.events !== null })
    var ctaImg = document.createElement('img')
    ctaImg.id = 'mdvp-cta-img'
    ctaImg.className = 'match-detail-video-panel__cta-img'
    if (playableChannelForImg && playableChannelForImg.image) ctaImg.src = playableChannelForImg.image
    ctaImg.alt = ''
    ctaPill.appendChild(ctaText)
    ctaWrap.appendChild(ctaImg)
    ctaWrap.appendChild(ctaPill)
    document.body.appendChild(ctaWrap)
    this._ctaWrap = ctaWrap
  }

  // ── Elimina el pill CTA del DOM y limpia sus event listeners ─────────────
  _removeCta () {
    if (!this._ctaWrap) return
    if (this._ctaPillClick) {
      var pill = document.getElementById('mdvp-cta-pill')
      if (pill) {
        pill.removeEventListener('click', this._ctaPillClick)
        if (this._ctaPillKeyDown) pill.removeEventListener('keydown', this._ctaPillKeyDown)
      }
    }
    if (this._ctaWrap.parentNode) this._ctaWrap.parentNode.removeChild(this._ctaWrap)
    this._ctaWrap = null
  }

  // ── Bloquea el scroll del contenedor principal mientras el player se posiciona ─
  // Se usa tanto overflow:hidden como un listener de scroll que restaura la posición,
  // para cubrir el caso en que el navegador o la navegación espacial haga scroll
  // programático antes de que el cambio de overflow tome efecto.
  // También bloquea el movimiento de foco mediante _lockFocus().
  _lockScroll () {
    var el = document.querySelector('.match-detail-body__content')
    if (!el) return
    el.style.overflow = 'hidden'
    if (!this._preventScrollHandler) {
      var lockedScrollTop = el.scrollTop
      this._preventScrollHandler = function () {
        el.scrollTop = lockedScrollTop
      }
      el.addEventListener('scroll', this._preventScrollHandler, { passive: true })
    }
    this._lockFocus()
  }

  _unlockScroll () {
    var el = document.querySelector('.match-detail-body__content')
    if (!el) return
    el.style.overflow = ''
    if (this._preventScrollHandler) {
      el.removeEventListener('scroll', this._preventScrollHandler)
      this._preventScrollHandler = null
    }
    this._unlockFocus()
  }

  // ── Bloquea el movimiento de foco con teclas de navegación ───────────────
  // Impide que flechas, OK y teclas de mando muevan el foco mientras el player
  // aún no terminó de cargar dentro de match-detail-video-panel__video.
  _lockFocus () {
    if (this._blockFocusHandler) return
    this._blockFocusHandler = function (e) {
      var navKeys = [37, 38, 39, 40, 13, 32, 179, 415]
      if (navKeys.indexOf(e.keyCode || e.which) !== -1) {
        e.preventDefault()
        e.stopImmediatePropagation()
      }
    }
    document.addEventListener('keydown', this._blockFocusHandler, true)
  }

  _unlockFocus () {
    if (this._blockFocusHandler) {
      document.removeEventListener('keydown', this._blockFocusHandler, true)
      this._blockFocusHandler = null
    }
  }

  // ── Devuelve true si .match-detail-video-panel está visible en el viewport ─
  _isPanelVisible () {
    var panel = document.querySelector('.match-detail-video-panel')
    if (!panel) return false
    var rect = panel.getBoundingClientRect()
    return rect.width > 0 && rect.height > 0 &&
           rect.bottom > 0 && rect.top < window.innerHeight
  }

  // ── Aplica estilos expandidos guardando los originales en this._orig ───────
  _expandForTabs () {
    if (this._isExpanded) return
    this._isExpanded = true

    // El top varía según si el carousel está visible en pantalla o no.
    var carousel = document.querySelector('.match-detail-video-panel__carousel')
    var carouselVisible = carousel
      ? (carousel.style.display !== 'none' && carousel.offsetParent !== null)
      : false
    var expandTop = carouselVisible ? '-37.2rem' : '-31.5rem'

    var tabs = document.querySelector('.match-detail-tabs')
    if (tabs) {
      this._orig.tabsPosition = tabs.style.position
      this._orig.tabsTop      = tabs.style.top
      this._orig.tabsZIndex   = tabs.style.zIndex
      tabs.style.position = 'relative'
      tabs.style.top      = expandTop
      tabs.style.zIndex   = '9999999999'
    }

    var body = document.querySelector('.match-detail-body')
    if (body) {
      this._orig.bodyTop    = body.style.top
      this._orig.bodyZIndex = body.style.zIndex
      this._orig.bodyHeight = body.style.height
      body.style.top    = expandTop
      body.style.zIndex = '9999999999'
      body.style.height = '63rem'
    }

    var content = document.querySelector('.match-detail-body__content')
    if (content) {
      this._orig.contentMaxHeight = content.style.maxHeight
      content.style.maxHeight = '60rem'
    }

    var inner = document.querySelector('.match-detail-body__inner')
    if (inner) {
      this._orig.innerPaddingBottom = inner.style.paddingBottom
      inner.style.paddingBottom = '2rem'
    }

    var rail = document.querySelector('.match-detail-body__scroll-rail')
    if (rail) {
      this._orig.railHeight = rail.style.height
      rail.style.height = 'calc(100% - 34rem)'
    }

    var ctaPill = document.getElementById('mdvp-cta-pill')
    if (ctaPill) {
      this._orig.ctaPillDisplay = ctaPill.style.display
      ctaPill.style.display = 'none'
    }

    var ctaText = document.querySelector('.match-detail-video-panel__cta-text')
    if (ctaText) {
      this._orig.ctaTextDisplay = ctaText.style.display
      ctaText.style.display = 'none'
    }

    var ctaImg = document.getElementById('mdvp-cta-img')
    if (ctaImg) {
      this._orig.ctaImgDisplay = ctaImg.style.display
      ctaImg.style.display = 'none'
    }

    var videoWrapper = document.getElementById('HTML5VideoWrapper')
    if (videoWrapper) {
      this._orig.videoWrapperZIndex = videoWrapper.style.zIndex
      videoWrapper.style.zIndex = '0'
    }

    var carousel = document.querySelector('.match-detail-video-panel__carousel')
    if (carousel) {
      this._orig.carouselDisplay = carousel.style.display
      carousel.style.display = 'none'
    }
  }

  // ── Restaura todos los estilos al estado previo a la expansión ───────────
  // Solo actúa si _isExpanded es true (garantía contra ejecuciones duplicadas).
  _collapseForChannels () {
    if (!this._isExpanded) return
    this._isExpanded = false
    var o = this._orig

    var tabs = document.querySelector('.match-detail-tabs')
    if (tabs) {
      tabs.style.position = o.tabsPosition !== undefined ? o.tabsPosition : ''
      tabs.style.top      = o.tabsTop      !== undefined ? o.tabsTop      : ''
      tabs.style.zIndex   = o.tabsZIndex   !== undefined ? o.tabsZIndex   : ''
    }

    var body = document.querySelector('.match-detail-body')
    if (body) {
      body.style.top    = o.bodyTop    !== undefined ? o.bodyTop    : ''
      body.style.zIndex = o.bodyZIndex !== undefined ? o.bodyZIndex : ''
      body.style.height = o.bodyHeight !== undefined ? o.bodyHeight : ''
    }

    var content = document.querySelector('.match-detail-body__content')
    if (content) content.style.maxHeight = o.contentMaxHeight !== undefined ? o.contentMaxHeight : ''

    var inner = document.querySelector('.match-detail-body__inner')
    if (inner) inner.style.paddingBottom = o.innerPaddingBottom !== undefined ? o.innerPaddingBottom : ''

    var rail = document.querySelector('.match-detail-body__scroll-rail')
    if (rail) rail.style.height = o.railHeight !== undefined ? o.railHeight : ''

    var ctaPill = document.getElementById('mdvp-cta-pill')
    if (ctaPill) ctaPill.style.display = o.ctaPillDisplay !== undefined ? o.ctaPillDisplay : ''

    var ctaText = document.querySelector('.match-detail-video-panel__cta-text')
    if (ctaText) ctaText.style.display = o.ctaTextDisplay !== undefined ? o.ctaTextDisplay : ''

    var ctaImg = document.getElementById('mdvp-cta-img')
    if (ctaImg) ctaImg.style.display = o.ctaImgDisplay !== undefined ? o.ctaImgDisplay : ''

    var videoWrapper = document.getElementById('HTML5VideoWrapper')
    if (videoWrapper) videoWrapper.style.zIndex = o.videoWrapperZIndex !== undefined ? o.videoWrapperZIndex : ''

    var carousel = document.querySelector('.match-detail-video-panel__carousel')
    if (carousel) carousel.style.display = o.carouselDisplay !== undefined ? o.carouselDisplay : ''

    this._orig = {}
  }

  // ── Listener global focusin ──────────────────────────────────────────────
  // Expansión: foco llega a .match-detail-body__content mientras el panel
  //            es visible en pantalla y no está ya expandido.
  // Colapso:   foco va a cualquiera de los 4 botones de tab (solo si expandido).
  _onDocFocusIn (e) {
    var target = e.target
    if (!target) return
    var id = target.id || ''

    // Expansión: el foco llega a CUALQUIER elemento dentro de .match-detail-body__content
    // (no solo al contenedor mismo), mientras el panel es visible y no está expandido.
    var scrollContainer = document.querySelector('.match-detail-body__content')
    var isInsideScroll = scrollContainer && scrollContainer.contains(target)
    if (isInsideScroll && !this._isExpanded && this._isPanelVisible()) {
      this._expandForTabs()
      return
    }

    // Colapso: cualquier tab recibe foco (solo si estaba expandido).
    var isAnyTab = id === 'match-detail-tab-stats'   ||
                   id === 'match-detail-tab-players'  ||
                   id === 'match-detail-tab-summary'  ||
                   id === 'match-detail-tab-lineups'
    if (isAnyTab) {
      this._collapseForChannels()
    }
  }

  // ── Despacha la reproducción y espera a que el player esté listo en el DOM ─
  async _dispatchAndObservePlayer (groupId, pinAlreadyValidated) {
    if (this._mounted) this.setState({ isLoading: true })
    setPendingMatchModal({ matchData: this.props.matchData, callback: this.props.callback })



    // Detectar si tenemos playbackData válido para usar flujo LITE
    var channels = this.props.channels || [];
    var currentChannel = channels.find(function (ch) { return ch.groupId === groupId });
    var hasPlaybackData = currentChannel && currentChannel.media && this._hasValidMediaData(currentChannel);
    const device_config = Device.getDevice().getConfig();
    const streamType = device_config && device_config.stream_type ? device_config.stream_type : 'smooth_streaming';

    // ── Transformar playbackData usando replaceSourceMedia SOLO para Hisense/Vidaa ──
    // Esto es crítico para Hisense/Vidaa que necesitan convertir la URL del manifest
    // en la URL del web-initiator antes de reproducir.
    var playbackDataToUse = currentChannel.media;
    var isHisenseVidaa = Utils.isHisense();
    var isNetrange = Utils.isNetrange();
    var isZeasn = Utils.isZeasn();

    if ((isHisenseVidaa || isNetrange || isZeasn) && playbackDataToUse && playbackDataToUse.videoUrl) {
      try {
        var device = Device.getDevice();
        var playerUtil = device.getPlayerUtil();

        logger.debug('[MatchDetailVideoPanel] Dispositivo Hisense/Vidaa o Netrange o Zeasn detectado - aplicando transformación de URL');

        // Construir PGM temporal con estructura esperada por replaceSourceMedia
        var tempPgm = {
          media: {
            video_url: playbackDataToUse.videoUrl,
            server_url: playbackDataToUse.serverUrl || '',
            challenge: playbackDataToUse.challenge || '',
            certificate_url: playbackDataToUse.certificate_url || ''
          }
        };

        // Llamar a replaceSourceMedia para transformar la URL (web-initiator en Hisense/Vidaa)
        var transformedPgm = await playerUtil.replaceSourceMedia(
          tempPgm,
          streamType,
          null, // provider
          null, // providerCode
          true, // isLive
          'live' // streamContentType
        );

        // Actualizar playbackData con la URL transformada
        if (transformedPgm && transformedPgm.media && transformedPgm.media.video_url) {
          playbackDataToUse = Object.assign({}, playbackDataToUse, {
            videoUrl: transformedPgm.media.video_url
          });
          logger.debug('[MatchDetailVideoPanel] URL transformada por replaceSourceMedia:', playbackDataToUse.videoUrl);
        }
      } catch (error) {
        logger.error('[MatchDetailVideoPanel] Error al transformar playbackData con replaceSourceMedia:', error);
        // En caso de error, continuar con el playbackData original
      }
    }

    // Despachar con las dimensiones del miniplayer desde el inicio para evitar que el
    // player se inicialice en pantalla completa. applyPlayerStyles() refuerza los estilos
    // CSS del contenedor, pero el player ya parte en la posición correcta.
    var pipSize = this.pipConfig
    store.dispatch(playFullMedia(Object.assign({
      playerstate: 'PLAYING',
      source: { videoid: this.payloadGroupId ? this.payloadGroupId : groupId },
      ispreview: false,
      islive: true,
      size: { top: pipSize.top, left: pipSize.left, width: pipSize.width, height: pipSize.height },
      ispip: false,
      showEpg: false,
      filterTV: undefined,
      event: null,
      playFromCard: true,
      playFromMatchDetail: true,
      playbackData: playbackDataToUse,
      mundial2026: true,
      streamType: streamType,
    }, pinAlreadyValidated ? { pinAlreadyValidated: true, skipPin: true } : {})))

    // Desconectar observer anterior antes de crear uno nuevo para evitar duplicados
    if (this._playerObserver) {
      this._playerObserver.disconnect()
      this._playerObserver = null
    }

    var self = this

    var applyAndCleanup = function () {
      var container = document.getElementById('Html5PlayerContainer_full')
      if (!container || !container.parentNode) return
      if (self._playerObserver) {
        self._playerObserver.disconnect()
        self._playerObserver = null
      }
      self.applyPlayerStyles()
      if (self._mounted) self.setState({ isLoading: false })
    }

    this._playerObserver = new MutationObserver((mutations) => {
      // Solo reaccionar cuando Html5PlayerContainer_full sea AÑADIDO al DOM.
      // Verificar addedNodes evita que el observer se desconecte prematuramente
      // cuando el contenedor ya existe del canal anterior y ocurre cualquier otra
      // mutación en el body antes de que el player anterior sea destruido.
      var wasAdded = mutations.some(function (mutation) {
        if (!mutation.addedNodes || mutation.addedNodes.length === 0) return false
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i]
          if (node.nodeType !== 1) continue
          if (node.id === 'Html5PlayerContainer_full') return true
          if (node.querySelector && node.querySelector('#Html5PlayerContainer_full')) return true
        }
        return false
      })
      if (!wasAdded) return
      applyAndCleanup()
    })
    this._playerObserver.observe(document.body, { childList: true, subtree: true })

    // Fallback: si el player reutiliza el contenedor sin recrearlo (el observer no
    // detecta ADDED), aplicar estilos directamente después de que el player se asiente.
    if (document.getElementById('Html5PlayerContainer_full')) {
      setTimeout(function () {
        // Solo actuar si el observer aún no disparó (todavía está activo)
        if (self._playerObserver) applyAndCleanup()
      }, 200)
    }
  }

  // ── Marca el canal como bloqueado y oculta el CTA ────────────────────────
  _markChannelBlocked (groupId, blockedList, numberOfChannels) {
    logger.debug('[MatchDetailVideoPanel] Canal bloqueado por pin parental:', groupId, '| Canales bloqueados:', blockedList)
    if (!this._mounted) return
    // Si el canal está bloqueado, no habrá reproducción: desbloquear scroll
    this.setState({ isLoading: false, isChannelBlocked: true, blockedGroupId: groupId, numberOfChannels: numberOfChannels })
    if (this._ctaWrap) this._ctaWrap.style.display = 'none'
    var ctaImg = document.getElementById('mdvp-cta-img')
    if (ctaImg) ctaImg.style.display = 'none'
  }

  // ── Verifica pin parental y decide si reproducir o mostrar bloqueo ────────
  _checkBlockedChannelAndPlay (groupId, numberOfChannels, updatedChannels) {

       // Validar que el canal tenga datos válidos de media antes de reproducir
    var channels = updatedChannels || this.props.channels || []
    var currentChannel = channels.find(function (ch) { return ch.groupId === groupId })
    if (currentChannel && !this._hasValidMediaData(currentChannel)) {
      logger.debug('[MatchDetailVideoPanel] _checkBlockedChannelAndPlay - Canal sin datos válidos de media:', groupId)
      if (this._mounted) this.setState({ hasInvalidMedia: true, isLoading: false })
      return
    }
    // Bloquear scroll inmediatamente al iniciar el cambio de canal
    logger.debug('[MatchDetailVideoPanel] Verificando bloqueo parental para canal:', groupId)
    // Si el PIN ya fue validado para este canal, verificar la respuesta de la API
    if (this.props.pinValidatedGroupId && this.props.pinValidatedGroupId === groupId) {
      var checkPinResponse = this.props.checkPinResponse
      var pinOk = checkPinResponse && checkPinResponse.data ? true : false
      logger.debug('[MatchDetailVideoPanel] PIN validado para canal:', groupId, '| checkPinResponse:', checkPinResponse, '| pinOk:', pinOk)
      if (pinOk) {
        this._dispatchAndObservePlayer(groupId, true)
      } else {
        // La respuesta de la API indica que el PIN no desbloquó el canal
        this._markChannelBlocked(groupId, [], numberOfChannels)
      }
      return
    }

    var pinState = store.getState().pinCodes
    var cachedBlocked = pinState && pinState.pin_channel && pinState.pin_channel.info
      ? pinState.pin_channel.info
      : null

    if (cachedBlocked !== null) {
      if (cachedBlocked.indexOf(groupId) < 0) {
        this._dispatchAndObservePlayer(groupId)
      } else {
        this._markChannelBlocked(groupId, cachedBlocked, numberOfChannels)
      }
      return
    }

    var blockedChannelsList = new BlockedChannels()
    blockedChannelsList
      .checkBlockedChannels()
      .then((response) => {
        channelBlockedUtil.set('blockedChannels', response)
        if (response.indexOf(groupId) < 0) {
          if (this._mounted) this._dispatchAndObservePlayer(groupId)
        } else {
          this._markChannelBlocked(groupId, response)
        }
      })
      .catch(() => {
        channelBlockedUtil.set('blockedChannels', [])
        if (this._mounted) this._dispatchAndObservePlayer(groupId)
      })
  }


  // ── Maneja el flujo de upsell cuando el usuario no tiene derechos de reproducción ──
  // Oculta el CTA pill y ejecuta PurchaseButtonInfov585 + checkSusc con timeout de 2 segundos.
  // Si la API responde, dispara el flujo de validación de PIN parental.
  // Si hay error o timeout, procede con el flujo normal de reproducción.
  _handleUpsellFlow (channel) {
    logger.debug('[MatchDetailVideoPanel] Iniciando flujo de upsell para canal:', channel.groupId)

    // Ocultar CTA pill al mostrar modal de upsell
    if (this._ctaWrap) {
      this._ctaWrap.style.zIndex = '0'
    }

    // Llamar a PurchaseButtonInfov585 con timeout de 2 segundos
    Promise.race([
      PurchaseButtonInfov585({ groupId: channel.groupId }),
      new Promise((resolve, reject) => {
        setTimeout(() => reject(new Error('PurchaseButtonInfov585 timeout after 2s')), 2000)
      })
    ])
      .then((pbi) => {
        logger.debug('[MatchDetailVideoPanel] PurchaseButtonInfov585 respondió:', pbi)

        // Guardar datos de la modal pendiente
        setPendingMatchModal({ matchData: this.props.matchData, callback: this.props.callback })

        // Ejecutar checkSusc de PlayerStreamingUtils
        var playerStreamingUtils = new PlayerStreamingUtils()
        asyncPinObserver.fire('awaitpbiInfo')

        playerStreamingUtils.checkSusc(null, channel.groupId, function () {}, {playFromMatchDetail: true})
          .then(() => {
            logger.debug('[MatchDetailVideoPanel] checkSusc completó para canal:', channel.groupId)
            asyncPinObserver.fire('pbiInfocomplete')
            // Validar bloqueo parental: si está bloqueado muestra overlay, si no reproduce
            this._checkBlockedChannelAndPlay(channel.groupId)
          })
          .catch((err) => {
            logger.error('[MatchDetailVideoPanel] Error en checkSusc:', err)
            // En caso de error, proceder con el flujo normal de reproducción
            this._checkBlockedChannelAndPlay(channel.groupId)
          })
      })
      .catch((err) => {
        logger.error('[MatchDetailVideoPanel] Error en flujo de upsell:', err.message)
        // Si hay error de timeout o API, proceder con el flujo normal
        this._checkBlockedChannelAndPlay(channel.groupId)
      })
  }

  // ── Ciclo de vida ─────────────────────────────────────────────────────────

  componentDidMount () {
    this._mounted = true
    this._saveOriginalStyles()

    var channels = this.props.channels || []
    this._createCtaPill(channels)

    // En escenario de error (playback:[], tabs:[]) el CTA queda por detrás del overlay de error
    if (this.props.hasPlaybackError && this._ctaWrap) {
      this._ctaWrap.style.zIndex = '0'
    }

    // ── Agregar listeners de focus/blur al mdvp-video-area ──────────────────────
    var videoArea = document.getElementById('mdvp-video-area')
    if (videoArea) {
      this._videoAreaFocus = function () {
        var ctaPill = document.getElementById('mdvp-cta-pill')
        if (ctaPill && ctaPill.focus) ctaPill.focus({ preventScroll: true })
      }
      this._videoAreaBlur = function () {
        var ctaPill = document.getElementById('mdvp-cta-pill')
        if (ctaPill && ctaPill.blur) ctaPill.blur()
      }
      videoArea.addEventListener('focus', this._videoAreaFocus)
      videoArea.addEventListener('blur', this._videoAreaBlur)
    }

    var self = this
    var playableChannel = channels.find(function (ch) { return ch.media !== null && ch.events !== null })

    // Validar que el canal tenga datos válidos de media
    if (playableChannel && !self._hasValidMediaData(playableChannel)) {
      logger.debug('[MatchDetailVideoPanel] Canal sin datos válidos de media:', playableChannel.groupId)
      logger.debug('[MatchDetailVideoPanel] Iniciando reintentos de playback...')
      self.setState({ isLoading: true, retryCount: 0 }, () => {
        self._retryPlayBackData()
      })
      return
    }

    var groupId = playableChannel ? playableChannel.groupId : null
    var numberOfChannels = playableChannel ? playableChannel.number : null

    // Si la modal se re-abre tras validar un PIN, usar ese canal como el inicial
    // en lugar del primer canal playable, para que _checkBlockedChannelAndPlay
    // entre al branch pinValidatedGroupId y lo reproduzca sin volver a pedir PIN.
    if (this.props.pinValidatedGroupId) {
      var self = this
      var validatedChannel = channels.find(function (ch) { return ch.groupId === self.props.pinValidatedGroupId })
      if (validatedChannel) {
        groupId = validatedChannel.groupId
        // Actualizar imagen del CTA al canal desbloqueado
        var ctaImgEl = document.getElementById('mdvp-cta-img')
        if (ctaImgEl && validatedChannel.image) ctaImgEl.src = validatedChannel.image
        // Resaltar el canal correcto en el carrusel (mismo orden que render)
        var sortedItems = channels.slice().sort(function (a, b) { return (a.name || '').localeCompare(b.name || '') })
        var validatedIndex = sortedItems.findIndex(function (ch) { return ch.groupId === validatedChannel.groupId })
        if (validatedIndex >= 0) this.setState({ focusedIndex: validatedIndex })
      }
    }

    asyncPinObserver.subscribe(this._handleMatchDetailParentalBlock)
    document.addEventListener('focusin', this._onDocFocusIn)

    if (groupId && !this.props.hasPlaybackError) {
      this.setState({ currentGroupId: groupId, focusedIndex: 0 })
      if (typeof this.props.onGroupChange === 'function') this.props.onGroupChange(groupId)
      this._checkBlockedChannelAndPlay(groupId, numberOfChannels)
    }
  }

    componentDidUpdate (prevProps, prevState) {
    // Si los channels cambiaron (ej: por actualización de playBackData),
    // disparar reproducción del nuevo canal playable
    if (prevProps.channels !== this.props.channels) {
      var channels = this.props.channels || []
      var playableChannel = channels.find(function (ch) { return ch.media !== null && ch.events !== null })

      // Validar que el canal tenga datos válidos de media
      if (playableChannel && !this._hasValidMediaData(playableChannel)) {
        logger.debug('[MatchDetailVideoPanel] Canal sin datos válidos de media en update:', playableChannel.groupId)
        logger.debug('[MatchDetailVideoPanel] Iniciando reintentos de playback...')
        this.setState({ isLoading: true, retryCount: 0 }, () => {
          this._retryPlayBackData()
        })
        return
      }

      if (playableChannel && playableChannel.groupId && !this.props.hasPlaybackError) {
        var existingContainer = document.getElementById('Html5PlayerContainer_full')
        var isSameChannel = this.state.currentGroupId === playableChannel.groupId

        // Si el player ya está en DOM y es el mismo canal, verificar si cambió la URL del video.
        // Si la URL no cambió (refresco de datos sin cambio de contenido), solo reaplicar estilos.
        // Si la URL cambió (ej: ventana pre-partido → stream en vivo al iniciar IN_PROGRESS),
        // re-despachar para reproducir el nuevo contenido (el dispatch ya usa pipConfig, sin fullscreen).
        if (existingContainer && existingContainer.parentNode && isSameChannel) {
          var prevChannels = prevProps.channels || []
          var prevPlayable = prevChannels.find(function (ch) { return ch.groupId === playableChannel.groupId })
          var prevVideoUrl = prevPlayable && prevPlayable.media && prevPlayable.media.videoUrl
          var newVideoUrl = playableChannel.media && playableChannel.media.videoUrl

          if (prevVideoUrl && newVideoUrl && prevVideoUrl === newVideoUrl) {
            logger.debug('[MatchDetailVideoPanel] Mismo canal y misma URL de media, reaplicando estilos miniplayer:', playableChannel.groupId)
            this.applyPlayerStyles()
            return
          }

          logger.debug('[MatchDetailVideoPanel] Mismo canal pero URL de media cambió, re-despachando nuevo contenido:', playableChannel.groupId)
        }

        logger.debug('[MatchDetailVideoPanel] Canales actualizados, disparando reproducción del canal:', playableChannel.groupId)
        this.setState({ currentGroupId: playableChannel.groupId, hasInvalidMedia: false, retryCount: 0, focusedIndex: 0 })
        if (typeof this.props.onGroupChange === 'function') this.props.onGroupChange(playableChannel.groupId)
        this._checkBlockedChannelAndPlay(playableChannel.groupId)
      }
    }
  }

  componentWillUnmount () {
    this._mounted = false
    // Limpiar listeners del mdvp-video-area
    var videoArea = document.getElementById('mdvp-video-area')
    if (videoArea) {
      if (this._videoAreaFocus) videoArea.removeEventListener('focus', this._videoAreaFocus)
      if (this._videoAreaBlur) videoArea.removeEventListener('blur', this._videoAreaBlur)
    }
    // Eliminar CTA pill del body
    if (this._ctaWrap) {
      var pill = document.getElementById('mdvp-cta-pill')
      if (pill) {
        if (this._ctaPillFocus) pill.removeEventListener('focus', this._ctaPillFocus)
        if (this._ctaPillBlur) pill.removeEventListener('blur', this._ctaPillBlur)
        if (this._ctaPillClick) pill.removeEventListener('click', this._ctaPillClick)
        if (this._ctaPillKeyDown) pill.removeEventListener('keydown', this._ctaPillKeyDown)
      }
      if (this._ctaWrap.parentNode) this._ctaWrap.parentNode.removeChild(this._ctaWrap)
      this._ctaWrap = null
    }
    asyncPinObserver.unsubscribe(this._handleMatchDetailParentalBlock)
    document.removeEventListener('focusin', this._onDocFocusIn)
    this._collapseForChannels()
    this._removeCta()
    // Detener reproducción al salir de la modal
    try {
      store.dispatch(playFullMedia({
        ispip: false,
        islive: false,
        ispreview: false,
        playerstate: AAFPLAYER_STOP,
        event: null,
        videoid: null
      }))
    } catch (err) {
      // silenciar errores al detener el player
    }
    // Detener el observer si aún no encontró el nodo
    if (this._playerObserver) {
      this._playerObserver.disconnect()
      this._playerObserver = null
    }
    var container = document.getElementById('Html5PlayerContainer_full')
    // Restaurar el z-index y position original del contenedor del player
    if (container && container.parentNode) {
      container.parentNode.style.zIndex = this._originalZIndex || ''
      container.parentNode.style.position = this._originalPosition || ''
    }
    // Restaurar estilos originales de Html5PlayerContainer_full (top, left, width, height)
    if (container) {
      if (this._originalContainerStyle) {
        container.style.top    = this._originalContainerStyle.top    || ''
        container.style.left   = this._originalContainerStyle.left   || ''
        container.style.width  = this._originalContainerStyle.width  || ''
        container.style.height = this._originalContainerStyle.height || ''
        this._originalContainerStyle = null
      } else {
        // fallback: limpiar los estilos aplicados por este componente
        container.style.top    = ''
        container.style.left   = ''
        container.style.width  = ''
        container.style.height = ''
      }
    }
    // Restaurar los estilos originales de #playerMain
    var playerMain = document.getElementById('playerMain')
    if (playerMain) {
      var pm = this._originalPlayerMainStyle
      playerMain.style.display      = pm ? pm.display      : 'none'
      playerMain.style.top          = pm ? pm.top          : ''
      playerMain.style.left         = pm ? pm.left         : ''
      playerMain.style.width        = pm ? pm.width        : ''
      playerMain.style.height       = pm ? pm.height       : ''
      playerMain.style.borderRadius = pm ? pm.borderRadius : ''
      this._originalPlayerMainStyle = null
    }
    // Restaurar class de #HTML5VideoWrapper
    var videoWrapper = document.getElementById('HTML5VideoWrapper')
    if (videoWrapper) {
      videoWrapper.className = this._originalVideoWrapperClass !== undefined ? this._originalVideoWrapperClass : 'full'
      this._originalVideoWrapperClass = null
    }
    // Restaurar style de #uxMain (sin style)
    var uxMain = document.getElementById('uxMain')
    if (uxMain) {
      if (this._originalUxMainStyle) {
        uxMain.setAttribute('style', this._originalUxMainStyle)
      } else {
        uxMain.removeAttribute('style')
      }
      this._originalUxMainStyle = null
    }
  }

  restorePlayerToOriginal () {
    var container = document.getElementById('Html5PlayerContainer_full')
    if (container) {
      if (container.parentNode) {
        container.parentNode.style.zIndex = this._originalZIndex || ''
        container.parentNode.style.position = this._originalPosition || ''
      }
      if (this._originalContainerStyle) {
        container.style.top    = this._originalContainerStyle.top    || ''
        container.style.left   = this._originalContainerStyle.left   || ''
        container.style.width  = this._originalContainerStyle.width  || ''
        container.style.height = this._originalContainerStyle.height || ''
      } else {
        container.style.top    = ''
        container.style.left   = ''
        container.style.width  = ''
        container.style.height = ''
      }
    }
    if(this.isSamsungOrsay){
      var orsayContainer = document.querySelector('.orsayFullContainer');
        if (orsayContainer) {
        orsayContainer.style.zIndex = '4';
      }
    }
    var playerMain = document.getElementById('playerMain')
    if (playerMain) {
      var pm = this._originalPlayerMainStyle
      playerMain.style.display      = pm ? pm.display      : ''
      playerMain.style.top          = pm ? pm.top          : ''
      playerMain.style.left         = pm ? pm.left         : ''
      playerMain.style.width        = pm ? pm.width        : ''
      playerMain.style.height       = pm ? pm.height       : ''
      playerMain.style.borderRadius = pm ? pm.borderRadius : ''
    }
    var videoWrapper = document.getElementById('HTML5VideoWrapper')
    if (videoWrapper) {
      videoWrapper.className = this._originalVideoWrapperClass !== undefined ? this._originalVideoWrapperClass : 'full'
    }
    var uxMain = document.getElementById('uxMain')
    if (uxMain) {
      if (this._originalUxMainStyle) {
        uxMain.setAttribute('style', this._originalUxMainStyle)
      } else {
        uxMain.removeAttribute('style')
      }
    }
  }

  applyPlayerStyles () {
    // Si está expandido en tabs, mantener el player oculto
    if (this._isExpanded) {
      var videoWrapper = document.getElementById('HTML5VideoWrapper')
      if (videoWrapper) {
        videoWrapper.style.zIndex = '0'
      }
      return
    }

    var isSingle = this.props.channels && this.props.channels.length === 1
    const { top, left, width, height } = this.pipConfig
    this.player.setPlayerSize(top, left, width, height)

    var container = document.getElementById('Html5PlayerContainer_full')
    if (container) {
      if (container.parentNode) container.parentNode.style.zIndex = '2147483646'
      container.style.top    = !this.isSamsungOrsay ? '0.2rem' : '5rem'
      container.style.left   =!this.isSamsungOrsay ? '0' : '64rem'
      container.style.width  = '53.5rem'
      container.style.height = isSingle ? '29.2rem' : '29.2rem'
    }

    if(this.isSamsungOrsay){
      var orsayContainer = document.querySelector('.orsayFullContainer');
      if (orsayContainer) {
        orsayContainer.style.zIndex = '9999999';
      }
    }
    var playerMain = document.getElementById('playerMain')
    if (playerMain) {
      playerMain.style.display      = 'block'
      playerMain.style.top          = '4.6rem'
      playerMain.style.left         = '64rem'
      playerMain.style.width        = '53.5rem'
      playerMain.style.height       = isSingle ? '29.2rem' : '29.2rem'
      playerMain.style.borderRadius = '1.6rem'
    }
    // Garantizar que el CTA (pill + imagen de canal) quede siempre por encima
    // del contenedor del player (z-index 2147483646)
    if (this._ctaWrap) this._ctaWrap.style.zIndex = '2147483647'
  }

  handleChannelFocus (index) {
    if (this._mounted) {
      this.setState({ focusedIndex: index })
      // Asegurar que el elemento reciba focus explícitamente
      // (importante para Android 4.4 con navegación espacial)
      var channelEl = document.getElementById('mdvp-channel-' + index)
      if (channelEl && channelEl.focus) {
        channelEl.focus({ preventScroll: true })
      }
    }
  }

  handleChannelKeyDown (e) {
    var key = e.key || ''
    if (key === 'ArrowUp' || e.keyCode === 38) {
      e.preventDefault()
      e.stopPropagation()

      // Si el overlay bloqueado está visible, ir allí primero
      if (this.state.isChannelBlocked) {
        var blockedOverlay = document.querySelector('.match-detail-video-panel__blocked-overlay')
        if (blockedOverlay && blockedOverlay.focus) {
          blockedOverlay.focus({ preventScroll: true })
          return
        }
      }

      // Si no hay overlay bloqueado, ir al CTA pill o al botón back
      var ctaPill = document.getElementById('mdvp-cta-pill')
      if (ctaPill && ctaPill.focus) {
        ctaPill.focus({ preventScroll: true })
      } else {
        var backBtn = document.querySelector('#btnMundialBack')
        if (backBtn && backBtn.focus) backBtn.focus({ preventScroll: true })
      }
      return
    }
    if (key === 'ArrowDown' || e.keyCode === 40) {
      e.preventDefault()
      e.stopPropagation()
      var focused = document.activeElement
      var focusedRect = focused ? focused.getBoundingClientRect() : null
      var focusedMid = focusedRect ? focusedRect.left + focusedRect.width / 2 : 0
      var allTabs = document.querySelectorAll('.match-detail-tabs__tab')
      var nearestTab = null
      var minDist = Infinity
      for (var i = 0; i < allTabs.length; i++) {
        var tab = allTabs[i]
        var rect = tab.getBoundingClientRect()
        var mid = rect.left + rect.width / 2
        var dist = Math.abs(mid - focusedMid)
        if (dist < minDist) {
          minDist = dist
          nearestTab = tab
        }
      }
      if (nearestTab && nearestTab.focus) nearestTab.focus({ preventScroll: true })
      return
    }
  }

  // Desplaza el track cuando el botón focalizado sale del viewport por la derecha.
  // Mantiene visible el máximo de botones posible sin centrar.
  getTrackOffset (focusedIndex, total) {
    var buttonStart = focusedIndex * CHANNEL_WIDTH_REM
    var buttonEnd   = buttonStart + CHANNEL_WIDTH_REM
    var totalWidth  = total * CHANNEL_WIDTH_REM

    var raw = 0

    // Si el botón está fuera del viewport por la derecha, desplazar
    if (buttonEnd > CHANNELS_WRAP_WIDTH) {
      raw = buttonEnd - CHANNELS_WRAP_WIDTH
    }

    // Limitar para no pasarse del final total
    raw = Math.min(Math.max(0, totalWidth - CHANNELS_WRAP_WIDTH), raw)

    return -raw
  }

  render () {
    var thumbnailUrl    = this.props.thumbnailUrl
    var channels        = this.props.channels || []
    var onSelectChannel = this.props.onSelectChannel
    var focusedIndex    = this.state.focusedIndex
    var hasChannels     = channels.length >= 1

    var items       = hasChannels ? channels.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')) : []
    // Filtrar el canal actual ANTES de calcular índices y navegación espacial
    var currentGroupId = this.state.currentGroupId
    var renderableItems = items.filter(function (ch) { return ch.groupId !== currentGroupId })
    var total       = renderableItems.length
    var trackOffset = hasChannels ? this.getTrackOffset(focusedIndex, total) : 0

  return (
    <div className={'match-detail-video-panel' + (!hasChannels ? ' match-detail-video-panel--no-channels' : '')}>

      {/* ── Área de video ── */}
      <div className='match-detail-video-panel__video-wrap'>
        <div
          id='mdvp-video-area'
          className='match-detail-video-panel__video focusable'
          style={{
            border: this.props.hasPlaybackError
              ? '0.267rem solid rgba(181, 181, 255, 0.10)'
              : ''
          }}
          onClick={() => {
            if (this.state.isChannelBlocked) {
              this._showPinModal()
            } else if (typeof onSelectChannel === 'function') {
              onSelectChannel(this.state.currentGroupId)
            }
          }}
        >
          {this.state.isLoading && (
            <Spinner className='match-detail-video-panel__spinner' />
          )}

           {(this.props.hasPlaybackError || this.state.hasInvalidMedia) && (
            <div className='match-detail-video-panel__error-overlay'>
              <div className='match-detail-video-panel__error-icon-wrap'>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 60 60"
                  fill="none"
                  preserveAspectRatio="xMidYMid meet"
                  aria-hidden="true"
                  className='match-detail-video-panel__error-icon'
                >
                  <path d="M8.04201 51.25C7.60795 51.25 7.21806 51.1439 6.87234 50.9318C6.52663 50.7197 6.25795 50.4399 6.06631 50.0925C5.86657 49.7476 5.75666 49.3742 5.7366 48.9721C5.71654 48.5701 5.82495 48.1718 6.06183 47.7775L27.9847 9.90751C28.222 9.51314 28.5186 9.22163 28.8746 9.03298C29.231 8.84433 29.6061 8.75 30.0001 8.75C30.394 8.75 30.7692 8.84433 31.1256 9.03298C31.4815 9.22163 31.7782 9.51314 32.0155 9.90751L53.9383 47.7775C54.1752 48.1718 54.2836 48.5701 54.2636 48.9721C54.2435 49.3742 54.1336 49.7476 53.9339 50.0925C53.7422 50.4399 53.4736 50.7197 53.1278 50.9318C52.7821 51.1439 52.3922 51.25 51.9582 51.25H8.04201ZM10.6656 47.4087H49.3346L30.0001 14.1176L10.6656 47.4087ZM30.0001 44.3555C30.5861 44.3555 31.0774 44.1573 31.4739 43.7608C31.8704 43.3643 32.0686 42.873 32.0686 42.287C32.0686 41.701 31.8704 41.2097 31.4739 40.8132C31.0774 40.4167 30.5861 40.2185 30.0001 40.2185C29.4141 40.2185 28.9228 40.4167 28.5263 40.8132C28.1298 41.2097 27.9316 41.701 27.9316 42.287C27.9316 42.873 28.1298 43.3643 28.5263 43.7608C28.9228 44.1573 29.4141 44.3555 30.0001 44.3555ZM30.0007 37.6576C30.5453 37.6576 31.0014 37.4736 31.3689 37.1057C31.7368 36.7374 31.9207 36.2811 31.9207 35.737V26.774C31.9207 26.2298 31.7366 25.7737 31.3682 25.4058C30.9999 25.0375 30.5436 24.8533 29.9994 24.8533C29.4548 24.8533 28.9988 25.0375 28.6313 25.4058C28.2634 25.7737 28.0794 26.2298 28.0794 26.774V35.737C28.0794 36.2811 28.2636 36.7374 28.632 37.1057C29.0003 37.4736 29.4565 37.6576 30.0007 37.6576Z" fill="white"/>
                </svg>
              </div>
              <p className='match-detail-video-panel__error-text'>
                No pudimos cargar la transmisión.<br />Intenta de nuevo.
              </p>
            </div>
          )}

          {!this.props.hasPlaybackError && !this.state.hasInvalidMedia && thumbnailUrl
            ? <img
                src={thumbnailUrl}
                alt='Preview del partido'
                className='match-detail-video-panel__thumbnail'
              />
            : (!this.props.hasPlaybackError && !this.state.hasInvalidMedia && <div className='match-detail-video-panel__thumbnail-placeholder' />)
          }

          {/* CTA "Presiona OK para ir al canal" */}

          {this.state.isChannelBlocked && (
            <a
              className='match-detail-video-panel__blocked-overlay focusable'
              tabIndex='0'
              onKeyDown={(e) => {
                var k = e.keyCode || e.which
                if (k === 13 || k === 32 || k === 179 || k === 415) {
                  e.preventDefault()
                  e.stopPropagation()
                  this._showPinModal()
                }
              }}
            >
              <div className='match-detail-video-panel__blocked-icon'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" fill="none" className='match-detail-video-panel__blocked-svg'>
                  <path d="M11.4985 39.1927C10.5922 39.1927 9.81641 38.87 9.17109 38.2247C8.52578 37.5794 8.20312 36.8036 8.20312 35.8973V18.7902C8.20312 17.8839 8.52578 17.1081 9.17109 16.4628C9.81641 15.8174 10.5922 15.4948 11.4985 15.4948H13.6719V11.849C13.6719 9.57274 14.47 7.6365 16.0663 6.04023C17.6625 4.44396 19.5988 3.64583 21.875 3.64583C24.1512 3.64583 26.0875 4.44396 27.6837 6.04023C29.28 7.6365 30.0781 9.57274 30.0781 11.849V15.4948H32.2515C33.1578 15.4948 33.9336 15.8174 34.5789 16.4628C35.2242 17.1081 35.5469 17.8839 35.5469 18.7902V35.8973C35.5469 36.8036 35.2242 37.5794 34.5789 38.2247C33.9336 38.87 33.1578 39.1927 32.2515 39.1927H11.4985ZM21.875 30.5338C22.7606 30.5338 23.5138 30.2236 24.1345 29.6032C24.7549 28.9825 25.0651 28.2294 25.0651 27.3437C25.0651 26.4581 24.7549 25.7049 24.1345 25.0842C23.5138 24.4638 22.7606 24.1536 21.875 24.1536C20.9894 24.1536 20.2362 24.4638 19.6155 25.0842C18.9951 25.7049 18.6849 26.4581 18.6849 27.3437C18.6849 28.2294 18.9951 28.9825 19.6155 29.6032C20.2362 30.2236 20.9894 30.5338 21.875 30.5338ZM16.4062 15.4948H27.3437V11.849C27.3437 10.3299 26.8121 9.03862 25.7487 7.97525C24.6853 6.91189 23.3941 6.3802 21.875 6.3802C20.3559 6.3802 19.0647 6.91189 18.0013 7.97525C16.9379 9.03862 16.4062 10.3299 16.4062 11.849V15.4948Z" fill="white"/>
                </svg>


              </div>
              <div className='match-detail-video-panel__blocked-texts'>
                <p className='match-detail-video-panel__blocked-title'>
                  Canal {this.state.numberOfChannels} bloqueado
                </p>
                <p className='match-detail-video-panel__blocked-desc'>
                  {'Presiona OK para ingresar tu PIN y\nacceder a este canal.'}
                </p>
              </div>
            </a>
          )}
        </div>

        <span className='match-detail-video-panel__audio-badge' aria-hidden='true'>
          <img src={Asset.get('eventodeportivo_partidos_formasdever_icono_audioencendido')} className='match-detail-video-panel__audio-icon' alt='' />
        </span>
      </div>

      {/* ── Carrusel de canales ── */}
      {channels.length > 1 ? (
        <div className='match-detail-video-panel__carousel'>
          <span className='match-detail-video-panel__carousel-label'>
            {Translations.get('eventodeportivo_partidos_formasdever_texto_otrasformasdever')}
          </span>
          <div className='match-detail-video-panel__channels-wrap'>
            <div
              className='match-detail-video-panel__channels'
              style={{ transform: 'translateX(' + trackOffset + 'rem)' }}
            >
              {renderableItems.map((channel, index) => {
                var snLeft  = '#mdvp-channel-' + ((index - 1 + total) % total)
                var snRight = '#mdvp-channel-' + ((index + 1) % total)
                return (
                  <a
                    key={index}
                    id={'mdvp-channel-' + index}
                    href='#'
                    className={'focusable match-detail-video-panel__channel' + (this.state.focusedIndex === index ? ' focused' : '')}
                    onFocus={() => {
                      // Evitar que el browser scrollee .match-detail-body__content
                      // al recibir foco (scroll-into-view del sistema de navegación espacial).
                      // Se captura el scrollTop actual y se restaura en el siguiente frame,
                      // que es cuando el browser aplica el desplazamiento por foco.
                      var _contentEl = document.querySelector('.match-detail-body__content')
                      if (_contentEl) {
                        var _savedScrollTop = _contentEl.scrollTop
                        requestAnimationFrame(function () { _contentEl.scrollTop = _savedScrollTop })
                      }
                      this.handleChannelFocus(index)
                    }}
                    onKeyDown={this.handleChannelKeyDown}
                    onClick={(e) => {
                      e.preventDefault()

                      store.dispatch(playFullMedia({
                        ispip: false,
                        islive: false,
                        ispreview: false,
                        playerstate: AAFPLAYER_STOP,
                        event: null,
                        videoid: null
                      }))

                      // Validar si el canal tiene derechos de reproducción
                      var hasMedia = channel.media !== null && channel.media !== undefined

                      // Validar que el canal tenga datos válidos de media
                      if (hasMedia && !this._hasValidMediaData(channel)) {
                        logger.debug('[MatchDetailVideoPanel] Canal seleccionado sin datos válidos de media:', channel.groupId)
                        this.setState({ hasInvalidMedia: true, isLoading: false, currentGroupId: channel.groupId, focusedIndex: 0 })
                        if (typeof this.props.onGroupChange === 'function') this.props.onGroupChange(channel.groupId)
                        return
                      }

                      // Actualizar imagen del CTA y groupId activo
                      var ctaImgEl = document.getElementById('mdvp-cta-img')
                      if (ctaImgEl && channel.image) ctaImgEl.src = channel.image

                      // Mostrar spinner y ocultar overlay de bloqueo si estaba visible
                      // Resetear focusedIndex a 0 cuando cambia el canal actual
                      this.setState({ currentGroupId: channel.groupId, isLoading: true, isChannelBlocked: false, hasInvalidMedia: false, focusedIndex: 0 })
                      if (typeof this.props.onGroupChange === 'function') this.props.onGroupChange(channel.groupId)

                      // Branching: si NO tiene derechos, ejecutar flujo de upsell; si no, reproducir normalmente
                      if (!hasMedia) {
                        this._handleUpsellFlow(channel)
                      } else {
                        this._checkBlockedChannelAndPlay(channel.groupId)
                      }
                    }}
                    data-sn-up='#btnMundialBack'
                    data-sn-left={snLeft}
                    data-sn-right={snRight}
                  >
                    <div className='match-detail-video-panel__channel-inner'>
                      {channel.logoUrl
                        ? <img
                            src={channel.logoUrl}
                            alt={channel.name || ''}
                            className='match-detail-video-panel__channel-logo'
                            onError={function (e) {
                              e.target.style.display = 'none'
                              var fallback = e.target.parentNode.querySelector('.match-detail-video-panel__channel-name')
                              if (fallback) fallback.style.display = 'inline-block'
                            }}
                          />
                        : null
                      }

                    <img
                      src={channel.image}
                      alt={channel.name || ''}
                      className='match-detail-video-panel__channel-name'
                      style={channel.logoUrl ? { display: 'none' } : {}}
                    />


                    </div>
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
  }
}

MatchDetailVideoPanel.propTypes = {
  thumbnailUrl: PropTypes.string,
  channels: PropTypes.arrayOf(
    PropTypes.shape({
      logoUrl: PropTypes.string,
      name: PropTypes.string,
      group_id: PropTypes.string
    })
  ),
  onSelectChannel: PropTypes.func,
  group_id: PropTypes.string,
  matchData: PropTypes.object,
  callback: PropTypes.func,
  pinValidatedGroupId: PropTypes.string,
  checkPinResponse: PropTypes.object,
  hasPlaybackError: PropTypes.bool
}

MatchDetailVideoPanel.defaultProps = {
  thumbnailUrl: '',
  channels: [],
  onSelectChannel: null,
  group_id: '',
  matchData: null,
  callback: null,
  pinValidatedGroupId: null,
  checkPinResponse: null,
  hasPlaybackError: false
}

export default MatchDetailVideoPanel




// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailVideoPanel/MatchDetailVideoPanel.jsx